import usePrivateAxios from '@/common/api/usePrivateAxios'
import { RoleValidationSchema } from '@/features/tcardRoles/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'

interface UseCreateEstablishmentRoleProps {
  permissions: { permission_id: string }[]
  onSuccess: () => void
  onError: (error: any) => void
}

export const useCreateEstablishmentRole = ({ permissions, onSuccess, onError }: UseCreateEstablishmentRoleProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createEstablishmentRole'],
    mutationFn: async (form: RoleValidationSchema) => {
      const payload = {
        display_name: form.display_name,
        description: form.description,
        permission_roles_attributes: permissions,
        level: Number(form.level) || 0,
      }

      return privateAxios.post('/establishment/roles', { ...payload })
    },
    onSuccess,
    onError,
  })
}
